import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { BackToRoute, PageTitle } from '@app/components';
import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { sharedMessages } from '@app/translations';
import { ROUTE, URLQuery } from '@app/constants';

import { AdvancedSearchForm } from './AdvancedSearchForm';

import './AdvancedSearchPage.scss';

const cnBem = createBemBlockBuilder(['advancedSearchPage']);

export const AdvancedSearchPage: FC = () => {
  const { $t } = useIntl();
  const queryParams = useQueryParams();

  return (
    <div className={cn(cnBem(), 'container')}>
      <Helmet>
        <title>
          {$t({
            id: 'advancedSearch.documentTitle',
            defaultMessage: 'Advanced search - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <BackToRoute
        text={$t(sharedMessages.back)}
        to={generateRouteParams({
          pathname: ROUTE.search,
          query: queryParams as URLQuery,
        })}
      />
      <PageTitle>{$t(sharedMessages.advancedSearch)}</PageTitle>
      <AdvancedSearchForm />
    </div>
  );
};
